<template>
  <div class="entry">
    <span v-if="!isAuthorized" class="entry__link" @click="handlerOpenModal">
      <svg class="entry__user">
        <use xlink:href="#svg-user"></use>
      </svg>
    </span>
    <a v-else :href="url" class="entry__link">
      <svg class="entry__user">
        <use xlink:href="#svg-user"></use>
      </svg>
      <span class="entry-circle">
        <svg class="entry-circle__icon">
          <use xlink:href="#svg-check"></use>
        </svg>
      </span>
    </a>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import useModal from '@use/useModal/useModal';
import SignIn from '@components/Cabinet/Entry/SignIn/SignIn.vue';

export default {
  name: 'Entry',
  data() {
    return {
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      isAuthorized: ({ personal }) => personal?.data.authInfo?.isAuthorized,
      url: ({ personal }) => personal?.data.authInfo?.url,
    }),
  },
  methods: {
    async handlerOpenModal() {
      this.modal.show(
        SignIn,
        {},
        {
          width: '900px',
          backgroundClose: false,
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.entry {
  display: inline-flex;
  position: relative;
  &__link {
    display: inline-flex;
    align-items: center;
    color: var(--text-colour-primary);
    cursor: pointer;
    &:hover {
      .entry__user {
        fill: var(--color-link-hover-dark);
        transform: scale(1.1);
      }
    }
  }
  &__user {
    width: 24px;
    height: 24px;
    fill: #030304;
    transition: 0.2s linear fill, 0.2s linear transform;
  }
}
.entry-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  background-color: #448757;
  position: absolute;
  top: -8px;
  right: -8px;
  &__icon {
    fill: #fff;
    width: 12px;
    height: 12px;
  }
}
</style>
